import { Stack } from '@mui/material';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { ApproveModal } from '../../../../components/modal/ApproveModal';
import { ModalText, useModalToggle } from '../../../../components/modal/Modal';
import { TableWarningButton } from '../../../../components/style/ButtonStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';

export default function DeleteCategoryButton({
  category,
  categoryId,
  getResult,
}: any) {
  const [removeResult, remove] = useAuthAxios({
    method: 'DELETE',
    url: `/api/v1/${category}/${categoryId}`,
  });
  const { on, open, close } = useModalToggle();

  return (
    <>
      <TableWarningButton onClick={open}>삭제</TableWarningButton>
      <ApproveModal
        on={on}
        onClose={close}
        title="삭제하시겠습니까?"
        children={
          <Stack direction="row" justifyContent="center" sx={{ pt: 3, pb: 5 }}>
            <ModalText>삭제된 데이터는 복구되지 않습니다.</ModalText>
          </Stack>
        }
        onConfirm={() => remove()}
        isPrimaryColor={false}
      />

      <ApiResultModal
        apiResult={removeResult}
        successCode={200}
        successTitle={<>삭제되었습니다.</>}
        successContent={`해당 카테고리가 삭제되었습니다.`}
        successConfirmText="목록으로 돌아가기"
        onSuccessClose={getResult}
        failTitle={<>관리자에게 문의해주세요.</>}
        failContent={'문제가 발생했습니다. 관리자에게 문의해주세요.'}
        onFailClose={close}
        ErrorCodeTable={{
          CATEGORY_IS_USED: {
            title: '유형 삭제 불가',
            content: `해당 유형을 사용하고 있는 시설물이 있을 경우 삭제할 수 없습니다.`,
          },
          SUB_CATEGORY_IS_USED: {
            title: '운동기구 삭제 불가',
            content: `해당 운동기구를 사용하고 있는 시설물이 있을 경우 삭제할 수 없습니다.`,
          },
          INSPECTION_RESULT_IS_USED: {
            title: '상태 삭제 불가',
            content: `해당 상태를 사용하고 있는 시설물이 있을 경우 삭제할 수 없습니다.`,
          },
          DEPARTMENT_IS_USED: {
            title: '부서 삭제 불가',
            content: `해당 부서를 사용하고 있는 시설물이 있을 경우 삭제할 수 없습니다.`,
          },
        }}
      />
    </>
  );
}
